import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ProductGallery from "../../../subscreen/customer/shop/ProductGallery";
import ProductInfo from "../../../subscreen/customer/shop/ProductInfo";
import ProductTabs from "../../../subscreen/customer/shop/ProductTabs";
import ProductCard from "../../../components/customer/shop/ProductCard";
import "../../../assets/css/customer/shop/screens/ProductDetail.css";
import AppContext from "../../../context/AppContext";
import axios from "axios";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isImageZoomed, setIsImageZoomed] = useState(false);
  const { baseUrl } = useContext(AppContext);

  const viewProductDetails = () => {
    setIsLoading(true);
    axios
      .get(`${baseUrl}/customer/products/viewProductDetails`, {
        params: { id: id },
      })
      .then((response) => {
        setIsLoading(false);
        console.log(response.data);
        setProduct(response.data.singleProduct);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log("error:", error);
      });
  };

  useEffect(() => {
    viewProductDetails();
  }, []);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);

    // Find product by ID
    // const foundProduct = productsData.find((p) => p.id === parseInt(id));

    // if (foundProduct) {
    //   setProduct(foundProduct);

    // Get related products (same category, excluding current product)
    // const related = productsData
    //   .filter(
    //     (p) => p.category === foundProduct.category && p.id !== foundProduct.id,
    //   )
    //   .slice(0, 4);

    // setRelatedProducts(related);
    // } else {
    // Product not found, redirect to shop
    // navigate("/shop");
    // }

    // setIsLoading(false);
  }, [id, navigate]);

  if (isLoading) {
    return (
      <div className="pd-loading-screen">
        <div className="pd-spinner"></div>
        <p>Loading product details...</p>
      </div>
    );
  }

  if (!product) {
    return null;
  }

  return (
    <div
      className={`pd-product-detail-screen ${isImageZoomed ? "pd-zoom-active" : ""}`}
    >
      {/* Back Arrow — takes the customer to the previous screen */}
      <button
        className="pd-back-arrow-btn"
        onClick={() => navigate(-1)}
        aria-label="Go back"
      >
        <ArrowLeft size={18} />
      </button>

      {/* Main Content */}
      <div className="pd-content-wrapper">
        {/* Product Section */}
        <div className="pd-product-section">
          {/* Product Gallery */}
          <div className="pd-gallery-column">
            <ProductGallery
              images={product.productimages}
              productName={product.name}
              onZoomChange={setIsImageZoomed}
            />
          </div>

          {/* Product Info */}
          <div className="pd-info-column">
            <ProductInfo product={product} />
          </div>
        </div>

        {/* Product Tabs */}
        <div className="pd-tabs-section">
          <ProductTabs product={product} />
        </div>

        {/* Related Products Section */}
        {relatedProducts.length > 0 && (
          <div className="pd-related-section">
            <div className="pd-related-header">
              <h2 className="pd-related-title">You May Also Like</h2>
              <p className="pd-related-subtitle">
                Similar products from the same category
              </p>
            </div>

            <div className="pd-related-grid">
              {relatedProducts.map((relatedProduct) => (
                <ProductCard key={relatedProduct.id} product={relatedProduct} />
              ))}
            </div>

            <div className="pd-view-all-wrapper">
              <Link
                to={`/shop?category=${product.category}`}
                className="pd-view-all-btn"
              >
                View All {product.category.replace("-", " ")} Products
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </Link>
            </div>
          </div>
        )}
      </div>

      {/* Back to Shop Button (Mobile) */}
      <button className="pd-back-to-shop" onClick={() => navigate("/shop")}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
        Back to Shop
      </button>
    </div>
  );
};

export default ProductDetail;
